/*!

=========================================================
* Paper Kit React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react plugin used to create switch buttons
import Switch from "react-bootstrap-switch";
// plugin that creates slider
import Slider from "nouislider";

// reactstrap components
import {
  Button,
  Label,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

import { APP_STORE_URL, PLAY_STORE_URL, DOWNLOAD_FALLBACK_URL } from "config/appLinks";

function SectionButtons() {
  const [activeTab, setActiveTab] = React.useState("1");
  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  React.useEffect(() => {
   /* if (
      !document
        .getElementById("sliderRegular")
        .classList.contains("noUi-target")
    ) {
      Slider.create(document.getElementById("sliderRegular"), {
        start: [37.5],
        connect: [true, false],
        step: 0.5,
        range: { min: 0, max: 100 }
      });
    }
    if (
      !document.getElementById("sliderDouble").classList.contains("noUi-target")
    ) {
      Slider.create(document.getElementById("sliderDouble"), {
        start: [20, 80],
        connect: [false, true, false],
        step: 1,
        range: { min: 0, max: 100 }
      });
    }*/
  });
  return (
    <>
      <div className="section section-buttons text-center">
     
      <Container className="store-container">
      <Row>
              <Col className="ml-auto mr-auto" md="8">
                <h2 className="title">Hayatınızı Kolaylaştırmak İstiyoruz</h2>
                <h5 className="description">
                  Flex Play spor alanında bir pazar yeri oluşturmayı hedefler.
                  Seni daha motive edecek mobil uygulamalarımızla hayatını hem
                  kolaylaştıracak hem de zaman kazanmanı sağlayacak bir spor
                  deneyimi yaşamanı istiyoruz.
                </h5>
                <br />
           
              </Col>
            </Row>
          <Row style={{justifyContent:"space-between"}}>
              <Col md="3">
                <div className="info">
                  <div className="icon icon-info">
                    <i className="nc-icon nc-zoom-split" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">Etrafındaki Tenis Kortları</h4>
                    <p className="description">
                      Sana en yakın tesisleri görebilir 
                      ve üye tesislerin özelliklerine 
                      erişebilirsin.
                    </p>
                    
                  </div>
                </div>
              </Col>
              <Col md="3">
                <div className="info">
                  <div className="icon icon-info">
                    <i className="nc-icon nc-calendar-60" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">Rezervasyon</h4>
                    <p>
                      Rezervasyonlarını mobil uygulamamız üzerinden 
                      saniyeler içerisinde yapabilir hayatını 
                      kolaylaştırabilirsin.
                    </p>
               
                  </div>
                </div>
              </Col>
              <Col md="3">
                <div className="info">
                  <div className="icon icon-info">
                    <i className="nc-icon nc-credit-card" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">Online Ödeme</h4>
                    <p>
                      Ödemeni mobil uygulama üzerinden yapabilir,
                      ve oyununa kortta başlayabilirsin.
                    </p>
                   
                  </div>
                </div>
              </Col>
             
            </Row>
          </Container>
         
          <Container className="store-container">
          
            <Row>
              <Col>
                <div className="section login-ihone">
                  <img alt="..." src={require("assets/img/3iphones.png")} />
                </div>
              </Col>
            
           </Row>
           <br />
            <br />
            <br />
            <div className="title text-center">
            <h3>FlexPlay'u şimdi indirin!</h3>
          </div>
            <Row className="store-container">
              <Col md="3" sm="3" xs="6">
                <a href={APP_STORE_URL || DOWNLOAD_FALLBACK_URL} target="_blank" rel="noopener noreferrer">
                  <img
                    alt="App Store'dan indir"
                    className="img-rounded img-responsive"
                    src={require("assets/img/app_store.png")}
                  />
                </a>
              </Col>
              <Col md="3" sm="3" xs="6">
                <a href={PLAY_STORE_URL || DOWNLOAD_FALLBACK_URL} target="_blank" rel="noopener noreferrer">
                  <img
                    alt="Google Play'den indir"
                    className="img-rounded img-responsive"
                    src={require("assets/img/play_store.png")}
                  />
                </a>
              </Col>
            </Row>
           
           </Container>
           <br />
            <br />
           {/*  <Container>
            
            <Row>
            <Col className="mr-auto ml-auto" md="2" sm="3">
                
                <div className="title circle">
                  <h3>10+</h3>
                  <p className="text-center">Kort</p>
                </div>
               
              </Col>
              <Col className="mr-auto ml-auto" md="2" sm="3">
              <div className="title circle">
                  <h3>4000+</h3>
                  <p className="text-center">Oyuncu</p>
                </div>
              </Col>
              <Col className="mr-auto ml-auto" md="2" sm="3">
              <div className="title circle">
                  <h3>12000+</h3>
                  <p className="text-center">Rezervasyon</p>
                </div>
              </Col>
            </Row>
          </Container> */}
      </div>
    </>
  );
}

export default SectionButtons;
